<template>
  <div ref="mainContainer">
    <el-container>
      <el-header height="80px">
        <el-menu
          background-color="#2B2D53"
          text-color="#fff"
          active-text-color="#E42F4A"
          menu-trigger="click"
          mode="horizontal"
          :router="true"
          :unique-opened="true"
          ref="nav">

          <el-menu-item :route="{ name: 'users' }" index="1" class="menu-item-brand">
            <svgicon name="idalgo"></svgicon>
            iDalgo
          </el-menu-item>

          <!-- submenu for changing the locale -->
          <i-dalgo-lang-selection></i-dalgo-lang-selection>

          <!-- submenu for logging out -->
          <i-dalgo-logout></i-dalgo-logout>

          <!-- submenu for going from one product to another -->
          <i-dalgo-multi-products></i-dalgo-multi-products>

        </el-menu>
      </el-header>
      <transition name="fade" mode="out-in">
        <router-view/>
      </transition>
      <el-footer>
        Made with 🥌 by iDalgo
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import iDalgoMultiProducts from '@/components/iDalgo-Nav-Menus/iDalgo-Multi-Products'
import iDalgoLangSelection from '@/components/iDalgo-Nav-Menus/iDalgo-Lang-Selection'
import iDalgoLogout from '@/components/iDalgo-Nav-Menus/iDalgo-Logout'

export default {
  name: 'iDalgo-Default',
  components: {
    iDalgoMultiProducts,
    iDalgoLangSelection,
    iDalgoLogout
  },
  methods: {
    handleClick (target) {
      while (target !== document && target) {
        if (target.classList.contains('el-submenu__title')) {
          // a menu button was clicked, do nothing
          return
        }
        target = target.parentNode
      }
      // no menu button was clicked, so close them all
      this.$refs['nav'].openedMenus = []
    }
  },
  mounted () {
    // every click on the page should be evaluated in order to close menus when needed
    this.$refs['mainContainer'].addEventListener('click', (event) => (this.handleClick(event.target)))
  },
  beforeDestroy () {
    this.$refs['mainContainer'].removeEventListener('click', (event) => (this.handleClick(event.target)))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
body, html {
  font-family: "robotoregular","Helvetica Neue",Helvetica,Arial,sans-serif;
  background: $light-gray;
}

.el-row > * {
  display: flex;
  padding: $default_padding;
}

.el-header {
  background: $color1;

  .el-menu {
    max-width: 1200px;
    border: none;
    height: 80px;
    margin: auto;

    & > .el-menu-item {
      height: 80px;
      line-height: 80px;
      color: $white !important;
      border-bottom: $white !important;
    }

    .el-submenu {
      float: right;

      &.menu-item-lang {
        width: 80px;
      }
    }

    .el-submenu__title {
      height: 80px !important;
      line-height: 80px !important;
    }
  }

  .menu-item-brand {
    font-size: 20px;
    svg {
      width: $default_padding * 2;
      height: $default_padding * 2;
      margin-right: $default_padding;
    }
  }
}

.deconnectIcon {
  color: $color2 !important;
  width: 12px !important;
  height: 12px !important;
}

.menu-item-lang-options {
  width: 80px;
  ul.el-menu {
    width: 100%;
    min-width: 0;
    padding: 0;
  }
}

.el-footer {
  background: #ebe3e3;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-main {
  max-width: 1200px;
  width: 100%;
  margin: auto;
  min-height: calc(100vh - 120px);
}

.button-icon {
  font-family: 'robotolight';
  display: flex;
  flex-flow: column;
  align-items: center;
  color: $logo-gray;
  font-size: 16px;

  span {
    padding-top: $default_padding / 4;
    font-size: 10px;
    color: $text-gray;
  }
}

.text-empty {
  background: darken($light-gray, 10%);
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 800px 104px;
  animation: placeHolderShimmer 3s forwards infinite ease-in-out;
}

pre {
  word-wrap: break-word;
  white-space: pre-wrap;
  padding: 20px 20px;
  color: $color1;
  font-family: 'robotoregular';
  font-size: 14px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s ease-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

@keyframes placeHolderShimmer{
  0%{
      background-position: -468px 0
  }
  100%{
      background-position: 468px 0
  }
}

</style>



// WEBPACK FOOTER //
// src/layouts/iDalgo-Default.vue